import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DrugTestingHero,
  DrugTestingPageShell,
  SampleTypeChoices,
  useDrugTestingCopy
} from "@/components/site/drug-testing/DrugTestingShared";
import { SamplingLocationsSection } from "@/components/site/SamplingLocationsSection";
import { drugTestingHref, privateDrugEnquiryHref } from "@/data/drugTesting";
import { PageMeta } from "@/components/site/PageMeta";

const DrogtestningPrivat = () => {
  const { lang, copy } = useDrugTestingCopy();
  const p = copy.privat;



  return (
    <DrugTestingPageShell breadcrumb={[{ label: p.label }]}>
      <PageMeta title={p.metaTitle} description={p.metaDescription} />
      <DrugTestingHero label={p.label} title={p.title}>
        <p>{p.subtitle}</p>
        <div className="flex flex-col gap-3 pt-2 sm:flex-row sm:flex-wrap sm:items-center">
          <Button asChild variant="hero" size="xl" className="w-full sm:w-auto">
            <a href="#provtyper">
              {p.primaryCta}
              <ArrowRight className="ml-2 h-4 w-4" />
            </a>
          </Button>
          <Button asChild variant="ghost-outline" size="xl" className="w-full sm:w-auto">
            <Link to={privateDrugEnquiryHref(lang, "privat")}>{p.secondaryCta}</Link>
          </Button>
        </div>
      </DrugTestingHero>

      <SampleTypeChoices purpose="privat" />

      <section className="pb-14 lg:pb-16">
        <div className="container-wide grid gap-8 lg:grid-cols-[1.4fr_1fr]">
          <div>
            <h2 className="font-display text-3xl font-semibold tracking-tight text-foreground sm:text-4xl">
              {p.howTitle}
            </h2>
            <p className="mt-4 text-base leading-relaxed text-muted-foreground">{p.howText}</p>
            <h2 className="mt-10 font-display text-2xl font-semibold tracking-tight text-foreground">
              {p.recipientTitle}
            </h2>
            <p className="mt-3 text-base leading-relaxed text-muted-foreground">{p.recipientText}</p>
            <Link
              to={drugTestingHref("forIntyg", lang)}
              className="mt-5 inline-flex items-center text-sm font-medium text-primary"
            >
              {p.recipientLink}
              <ArrowRight className="ml-1.5 h-4 w-4" />
            </Link>
          </div>
          <aside className="rounded-3xl border border-border/60 bg-card p-7 shadow-card h-fit">
            <h2 className="font-display text-xl font-semibold text-foreground">{p.moreTitle}</h2>
            <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{p.moreText}</p>
            <Button asChild variant="hero" size="lg" className="mt-6 w-full">
              <Link to={privateDrugEnquiryHref(lang, "privat")}>{p.moreCta}</Link>
            </Button>
          </aside>
        </div>
      </section>

      <SamplingLocationsSection className="bg-muted/20" />
    </DrugTestingPageShell>
  );
};

export default DrogtestningPrivat;
